import { Component, inject, Input } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { UtilityService } from 'src/app/_services/utility.service';

@Component({
  selector: 'app-modal-max-smart',
  templateUrl: './modal-max-smart.component.html',
  styleUrls: ['./modal-max-smart.component.css']
})
export class ModalMaxSmartComponent {
  private readonly _modalRef: NzModalRef = inject(NzModalRef);
  public readonly utilityService: UtilityService = inject(UtilityService);

  @Input() user: any;
  @Input() maxSmart: number = 0;

  ngOnInit() {
    console.log(this.user);
  }

  closeModal() {
    this._modalRef.close(null);
  }

  save() {
    this._modalRef.close(this.maxSmart);
  }
}
